import { ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { I18nService } from 'src/app/services/i18n.service';
import { extractLink } from '../post-deal/post-deal.component';

const DISMISSED_UNTIL_KEY = 'post_banner_dismissed_until';
const DISMISS_DAYS = 30;

// Invitation à poster un deal en haut des listes : le lien est transmis à /poster, qui l'analyse et demande la connexion si besoin
@Component({
    selector: 'app-post-deal-banner',
    templateUrl: './post-deal-banner.component.html',
    styleUrls: ['./post-deal-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PostDealBannerComponent implements OnInit {

  visible = true;
  canPaste = false;
  url = '';
  error = '';

  constructor(
    private router: Router,
    private i18n: I18nService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.canPaste = !!navigator.clipboard?.readText;
      this.visible = !this.isDismissed();
    }
  }

  submit(): void {
    const typed = this.url.trim();
    const link = extractLink(typed);
    if (typed && !link) {
      this.error = this.i18n.t('post.bannerInvalidLink');
      return;
    }
    this.openPoster(link);
  }

  async pasteLink(): Promise<void> {
    try {
      const link = extractLink(await navigator.clipboard.readText());
      if (link) {
        this.openPoster(link);
      } else {
        this.error = this.i18n.t('post.pasteNoLink');
      }
    } catch {
      this.error = this.i18n.t('post.pasteNoLink');
    }
  }

  dismiss(): void {
    this.visible = false;
    try {
      localStorage.setItem(DISMISSED_UNTIL_KEY, String(Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000));
    } catch { }
  }

  private openPoster(link: string): void {
    this.router.navigate(['/poster'], link ? { queryParams: { url: link } } : {});
  }

  private isDismissed(): boolean {
    try {
      return Number(localStorage.getItem(DISMISSED_UNTIL_KEY)) > Date.now();
    } catch {
      return false;
    }
  }
}
